import { setAccessToken } from '../AsyncStorage';
import baseService from '../services/baseService';

export const setAccessTokenRedirect = () => {
    const token = baseService.defaults.headers.common['X-User-Token'];
    if (token) {
        setAccessToken(token);
    }
};
